import React, { useState } from 'react'
import logo from './logo.png'
import './Login.css'
import {Link,useHistory} from 'react-router-dom'
import {auth} from './firebase'

function Login() {
    const history = useHistory()
    const [email,setEmail]=useState('')
    const [password, setPassword] = useState('')

    const signIn=(event)=>{
        event.preventDefault()

        auth    
            .signInWithEmailAndPassword(email,password)
            .then((auth)=>{
                if(auth){
                    history.push("/")
                }
            })
            .catch(error=>alert(error.message))
    }

    const register=(event)=>{
        event.preventDefault()
        
        auth
            .createUserWithEmailAndPassword(email,password)
            .then((auth)=>{
                if(auth){
                    history.push("/")
                }
            })
            .catch(error=>alert(error.message))
    }

    const handleChangeMail=(event)=>{
        setEmail(event.target.value)
    }

    const handleChangePassword=(event)=>{
        setPassword(event.target.value)
    }

    return (
        <div className="login">
            <Link to="/">
            <img 
            className="login__logo"
            src={logo} alt="Amazon"
            />
            </Link>
            <div className="login__container">
                <h1>Sign-in</h1>
                <form>
                    <h5>E-mail</h5>
                    <input type="text" value={email} onChange={handleChangeMail}></input>
                    
                    <h5>Password</h5>
                    <input type="password" value={password} onChange={handleChangePassword}></input>
                    
                    <button type="submit" onClick={signIn} className="login__signInButton">Sign In</button>
                </form>

                <p>
                Al continuar, aceptas las Condiciones de uso y el Aviso de privacidad de Amazon.
                </p>

                <button onClick={register} className="login__registerButton">Create your Amazon Account</button>
            </div>
        </div>
    )
}

export default Login
